import React, { useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { MigrantContext } from '../../../../contexts/migrantContext'
import styles from './pageTitle.module.css'
import walletIcon from './../../../../assets/icon-wallet.svg'
import { AuthContext, AuthState } from '../../../../contexts/authContext'

interface PageTitleProps {
  title: string
}

const PageTitle = ({ title }: PageTitleProps) => {
  const isLoggedIn = useContext(AuthContext)?.authState === AuthState.signedIn
  const bal = useContext(MigrantContext)?.credits?.currentBalance ?? 0

  return (
    <Row>
      <Col>
        <h1 className="pageTitle" data-testid="pageTitle">
          {title}
        </h1>
      </Col>

      {isLoggedIn && (
        <Col className="text-right" xs="auto" data-testid="walletBalance">
          <Link to="/wallet">
            <div className={styles.button}>
              <div className={styles.iconWrapper}>
                <img
                  className={styles.icon}
                  src={walletIcon}
                  alt="wallet icon"
                />
              </div>
              <div className={styles.balanceWrapper}>
                <span className={styles.balance} data-testid="formattedCredits">
                  {bal.toLocaleString()}
                </span>{' '}
                BMC
              </div>
            </div>
          </Link>
        </Col>
      )}
    </Row>
  )
}

export default PageTitle
